import React, { useEffect } from 'react';
import { load as loadTeam } from 'js/actions/team-actions';
import { connect, useSelector } from 'react-redux';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useParams,
} from 'react-router-dom';
import { denormalize } from 'normalizr';
import { SCHEMAS } from 'js/api';

import TeamDashboardShellContainer from './TeamDashboardShellContainer';
import NewConnectorConfigurationContainer from './NewConnectorConfigurationContainer';
import EditConnectorConfigurationContainer from './EditConnectorConfigurationContainer';

function TeamRouter({ loadTeam }) {
  const { teamId, workspaceId } = useParams();
  const match = useRouteMatch();
  const team = useSelector((state) =>
    denormalize(state.entities.teams[teamId], SCHEMAS.TEAM, state.entities)
  );

  useEffect(() => {
    loadTeam(teamId);
  }, [teamId, loadTeam]);

  return (
    <Switch>
      <Route
        path={`${match.path}/settings/connectors/new/:connectorId`}
        render={(props) => (
          <NewConnectorConfigurationContainer {...props} team={team} />
        )}
      />
      <Route
        path={`${match.path}/settings/connectors/new`}
        render={(props) => (
          <NewConnectorConfigurationContainer {...props} team={team} />
        )}
      />
      <Route
        path={`${match.path}/settings/connectors/:teamConnectorConfigurationId`}
        render={(props) => (
          <EditConnectorConfigurationContainer {...props} team={team} />
        )}
      />
      <Route
        path={`${match.path}/connectors/:connectorComponent/:connectorId`}
        render={(props) => (
          <TeamDashboardShellContainer {...props} team={team} />
        )}
      />
      <Route
        exact
        path={`${match.path}/dashboard`}
        render={(props) => (
          <TeamDashboardShellContainer {...props} team={team} />
        )}
      />
      <Route
        exact
        path={`${match.path}/settings`}
        render={(props) => (
          <TeamDashboardShellContainer {...props} team={team} />
        )}
      />
      <Route exact path={match.path}>
        <Redirect to={`/w/${workspaceId}/teams/${teamId}/dashboard`} />
      </Route>
      <Route
        path={`${match.path}`}
        render={(props) => (
          <TeamDashboardShellContainer {...props} team={team} />
        )}
      />
    </Switch>
  );
}

export default connect(null, {
  loadTeam,
})(TeamRouter);
